import React, { memo } from 'react';
import classnames from 'classnames/bind';
import styles from "../../styles.pcss";
var cn = classnames.bind(styles);
export var DesktopText = /*#__PURE__*/memo(function () {
  return /*#__PURE__*/React.createElement("p", {
    className: cn('text'),
    "data-t-id": "components-DesktopText"
  }, "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0444\u0430\u0439\u043B \u0441\u044E\u0434\u0430 \u0438\u043B\u0438", /*#__PURE__*/React.createElement("span", {
    className: cn('text--special')
  }, " \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0430 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435"));
});